import React, { useEffect, useState } from 'react';
import ActionButton from '../ActionButton/';

const InteractContainer = ({
  readMessagesMutation,
  config,
  overwriteOpen = false,
  droplet,
  hideButton,
  openOnFirstTime,
}) => {
  const {
    action: { autoOpen = false },
  } = config;

  let initialOpen = false;
  if (overwriteOpen !== undefined) {
    // If overwriteOpen is explicitly set, use it
    initialOpen = overwriteOpen;
  } else if (openOnFirstTime === false) {
    // If openOnFirstTime is explicitly false, never open automatically
    initialOpen = false;
  } else if (openOnFirstTime === true) {
    // If openOnFirstTime is true, open it (first time behavior)
    initialOpen = true;
  } else {
    // Otherwise, use autoOpen setting from server
    initialOpen = autoOpen;
  }

  const [open, setOpen] = useState(initialOpen);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    window.parent.postMessage(JSON.stringify({ action: open ? 'open' : 'close' }), '*');
    window.parent.postMessage(JSON.stringify({ action: 'read_messages' }), '*');
  }, [open]);

  useEffect(() => {
    const messageHandler = event => {
      try {
        const parsedData = JSON.parse(event.data);
        if (parsedData.action === 'new_messages') return setNotificationCount(parsedData.payload.count);
        if (parsedData.action === 'read_messages') {
          return setNotificationCount(0);
        }
        if (parsedData.action === 'open') {
          setOpen(true);
        }
        if (parsedData.action === 'close') {
          setOpen(false);
        }
      } catch (error) {
        console.error(error);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, []);

  return (
    <>
      <div
        id="button-container"
        style={{
          position: 'fixed',
          right: '0px',
          bottom: '0px',
          zIndex: '1400',
          height: '100%',
          width: '100%',
          ...(hideButton && { display: 'none' }),
        }}
      >
        <ActionButton
          droplet={droplet}
          onClick={() => {
            setOpen(!open);
          }}
          open={open}
          config={config}
        />
      </div>
      {!!notificationCount && !open && !hideButton && (
        <div
          id="webchat_client_interact_button_counter"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            background: 'red',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '20px',
            height: '20px',
            zIndex: 10000,
          }}
        >
          {notificationCount}
        </div>
      )}
    </>
  );
};

export default InteractContainer;
